module.exports = __webpack_public_path__ + "img/item-1.f9459a8a.png";